import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { updateUser } from "../../features/userSlice/userSlice";
import { toast } from "react-toastify";

const UpdateUserDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedData = location.state;

  const [errors, setErrors] = useState("");
  const [errorData, setErrorData] = useState([]);
  const [loginError, setLoginError] = useState("");
  const [showToaster, setShowToaster] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    mobile_no: "",
    credit_in: "",
  });

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      name: selectedData.name || "",
      mobile_no: selectedData.mobile_no || null,
    }));
  }, [selectedData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdate = () => {
    try {
      const payload = {
        user_id: selectedData.id || 0,
        name: formData.name,
        mobile_no: formData.mobile_no,
        credit_in: Number(formData.credit_in || 0),
      };
      console.log("payload data ==>", payload);
      dispatch(updateUser(payload))
        .unwrap()
        .then((result) => {
          if (result.status) {
            setShowToaster(true);
            toast.success(result.message, {
              onClose: () => {
                navigate("/create-new-user");
                setFormData({
                  name: "",
                  mobile_no: "",
                  credit_in: null,
                });
              },
            });
          } else {
            setErrorData(result.form_err);
          }
        })
        .catch((err) => {
          setErrorData(err.form_err || []);
          toast.error(err.message);
        });
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const mapErrors = (errorData) => {
    const errorMap = {};
    errorData.forEach((error) => {
      if (!errorMap[error.param]) {
        // errorMap[error.param] = error.msg;
        const path = error.param.split(".").join("_");
        errorMap[path] = error.msg;
      }
    });
    return errorMap;
  };

  const handleCancel = () => {
    navigate("/create-new-user");
  };

  useEffect(() => {
    const errorsValue = mapErrors(errorData);
    setErrors(errorsValue);
  }, [errorData]);

  return (
    <>
      <>
        <div className="row justify-content-center">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-sm-12">
                <h4 className="text-center">Update User Details</h4>
              </div>
            </div>
          </div>

          <div className="col-md-12 col-lg-12 col-xl-6">
            <div className="card">
              <div className="card-body">
                <div class="mb-3">
                  <label className="form-label mb-2">Name</label>
                  <input
                    type="text"
                    className="form-control pe-5"
                    name="name"
                    placeholder="Enter Name"
                    value={formData.name}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />

                  {errors.name && (
                    <div className="text-danger">{errors.name}</div>
                  )}
                </div>
                <div class="mb-3">
                  <label className="form-label mb-2">Mobile No</label>
                  <input
                    type="text"
                    className="form-control pe-5"
                    name="mobile_no"
                    placeholder="Enter mobile no."
                    value={formData.mobile_no}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />

                  {errors.mobile_no && (
                    <div className="text-danger">{errors.mobile_no}</div>
                  )}
                </div>
                <div class="mb-3">
                  <label className="form-label mb-2">
                    Available Amount : {selectedData.credit_in}
                  </label>
                  <input
                    type="text"
                    className="form-control pe-5"
                    name="credit_in"
                    placeholder="Enter credit"
                    value={formData.credit_in}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />

                  {errors.credit_in && (
                    <div className="text-danger">{errors.credit_in}</div>
                  )}
                </div>

                <div className="d-flex justify-content-end">
                  <Button
                    variant="danger"
                    className="me-2"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    onClick={handleUpdate}
                    disabled={
                      !formData.name ||
                      !formData.mobile_no ||
                      !formData.credit_in
                    }
                  >
                    Update
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default UpdateUserDetails;
